package com.merkost.handpass.sharedweb.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.theme.AnimNames
import com.merkost.handpass.sharedweb.theme.Dur
import com.merkost.handpass.sharedweb.theme.Ease
import com.merkost.handpass.sharedweb.theme.SkeletonHighlight
import com.merkost.handpass.sharedweb.theme.SurfaceMuted
import com.merkost.handpass.sharedweb.theme.WebSkeletonMetrics
import com.varabyte.kobweb.compose.css.Animation
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val WebSkeletonStyle = CssStyle.base {
    Modifier
        .backgroundColor(SurfaceMuted.value())
        .animation(
            Animation.of(
                name = AnimNames.Shimmer,
                duration = Dur.Shimmer,
                timingFunction = Ease.Linear,
                iterationCount = AnimationIterationCount.Infinite,
            )
        )
        .styleModifier {
            property(
                "background-image",
                "linear-gradient(90deg, ${SurfaceMuted.value()} 0%, ${SkeletonHighlight.value()} 50%, ${SurfaceMuted.value()} 100%)"
            )
            property("background-size", "200% 100%")
            property("background-repeat", "no-repeat")
        }
}

@Composable
fun WebSkeleton(modifier: Modifier = Modifier) {
    Div(attrs = WebSkeletonStyle.toModifier().then(modifier).toAttrs { attr("aria-hidden", "true") }) {}
}

@Composable
fun WebSkeletonRow(
    heightPx: Int = WebSkeletonMetrics.DefaultHeight,
    widthFraction: Double = 1.0,
    radiusPx: Int = WebSkeletonMetrics.DefaultRadius,
) {
    WebSkeleton(
        modifier = Modifier
            .height(heightPx.px)
            .width((widthFraction * 100).percent)
            .borderRadius(radiusPx.px)
    )
}
